import Rest from '../rest'

/******************************************************************************
 *  Funnels
 *****************************************************************************/

/**
 * @type {Funnel}
 */
export default class Funnel extends Rest {

    constructor () {
        super('/funnel')
    }

    getStages(config) {
        return this.getAll('/stage', {}, config)
    }

    getStagesV2(config) {
        return this.getAllV2('/stage', {}, config)
    }

    getStatusByStage(stage) {
        return this.getAll('/status', { funnel_stage_id: stage })
    }

    getStatus() {
        return this.getAllV2('/stage', {}).then(response => {
            let statusList = []
            if(response.data.data) {
                response.data.data.forEach(stage => {
                    if (stage.status && stage.status.length > 0) {
                        stage.status.forEach(status => {
                            statusList.push({
                                ...status,
                                funnel_stage_id: stage.id,
                                funnel_stage_name: stage.name
                            })
                        })
                    }
                })

                response.data = [...statusList]
            }
            return response
        })
    }

    /**
     * Busca os grupos de campos cadastrados no banco e formata-os de modo
     * a serem utilizados em um select-tag
     */
    getFieldGroups(config) {
        return this.getAll('/deal/group', {}, config)
            .then(response => {
                let notAllowedFields = ['repeater', 'file', 'separator']
                let data = Object.values(response.data).map(group => {
                    let allowedFields = Object.values(group.fields).filter(field => !(notAllowedFields.includes(field.type)))
                    group.fields = [...allowedFields]
                    return group
                })
                response.data = [...data]

                return response
            })
    }

    /**
     * Cria uma instância de deal de acordo com os dados passados como parâmetro
     */
    createDeal(data) {
        return this.create('/deal', data)
    }
    
    duplicateDeal(dealId) {
        return this.createV2(`/deal/${dealId}/copie`)
    }


    getDeal(dealId) {
        return this.getAllV2(`/deal/${dealId}`)
    }

    getMonetaryFields(){
        return this.getAll('/deal/group/monetary')
    }

	createStage(data) {
		return this.create('/stage', data)
	}

	updateStage(data, id) {
		return this.update(`/stage`, id, data)
	}

	/**
	 * Função responsável por editar a ordem de stage ou status do funnel.
	 */
	reorder(data, status = 'stage') {
		return this.create(`/${status}/reorder`, data)
	}

    updateDynamic(dealId, groupId, data) {
        if(dealId && groupId)
            return this.updateDataFieldDynamic(`/deal/${dealId}/group`, groupId, data)
    }

    getAllowGroupDuplicateDeal(){
        return this.getAllV2('/limit-groups')
    }

    updateAllowGroupDuplicateDeal(data){
        return this.updateV2('/configurations/allowGroupDuplicateDeal', "", data)
    }
    getUsersWithPermissions(data) {
        return this.getAllV2(`/users-privilege`, data)
    }

    updateAllowBulkStageStatusChange(data){
        return this.updateV2('/configurations/allowBulkStageStatusChange', "", data)
    }

    getAllUsers(data) {
        return this.getAllV2(`/users-privilege`, data)
    }

    updateResponsible(dealId, data) {
        if(dealId) {
            return this.updateV2(`/deal/${dealId}/change-owner`, "", data)
        }
    }

    /**
     * GET - Busca a configuração de alteração em massa de responsáveis
     */
    // getAllowBulkChangeDealOwner() {
    //     return this.getAllV2('/configurations/AllowBulkChangeDealOwner')
    // }
    
    /**
     * PUT - Atualiza a configuração de alteração em massa de responsáveis
     */
    updateAllowBulkChangeDealOwner(data) {
        return this.updateV2('/configurations/allowBulkChangeDealOwner', '', data)
    }

}
